import React, { useState } from 'react';
import Button from '../../components/shared/Button';
import { runFullTestScenario } from '../../services/debug/scenarioRunner';

const TestRunner = () => {
    const [logs, setLogs] = useState([]);
    const [isRunning, setIsRunning] = useState(false);

    const addLog = (logItem) => {
        setLogs(prev => [...prev, logItem]);
    };

    const handleRun = async () => {
        setIsRunning(true);
        setLogs([]);
        await runFullTestScenario(addLog);
        setIsRunning(false);
    };

    return (
        <div className="container pt-xl">
            <h1 className="mb-lg">System Integration Test</h1>

            <div className="card mb-lg">
                <p className="mb-md">
                    Create Transporter &rarr; Create Vehicle &rarr; Create Reservation &rarr; Gate Entry &rarr; Loading Start/End &rarr; Exit.
                </p>
                <div className="flex gap-md">
                    <Button onClick={handleRun} disabled={isRunning} variant="primary">
                        {isRunning ? 'Running...' : 'Run Scenario'}
                    </Button>
                    <Button onClick={() => setLogs([])} variant="secondary">Clear Logs</Button>
                </div>
            </div>

            <div className="card bg-surface-subtle font-mono text-sm" style={{ minHeight: '300px', maxHeight: '600px', overflowY: 'auto' }}>
                {logs.length === 0 && <span className="text-secondary">Ready to test...</span>}
                {logs.map((log, index) => (
                    <div key={index} className={`mb-xs ${log.type === 'error' ? 'text-danger' : 'text-success'}`}>
                        <span className="text-secondary mr-sm">[{log.time}]</span>
                        {log.msg}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TestRunner;
